import { LoadingButton } from "@mui/lab";
import { Grid } from "@mui/material";
import { FormProvider, RHFTextField } from "src/components/hook-form";
import useLocales from "src/hooks/useLocales";

import useCreateClientForm from "./useCreateClientForm";

// ----------------------------------------------------------------------

export default function CreateClientForm() {
	const { translate } = useLocales();

	const { methods, isLoading, onSubmit } = useCreateClientForm();

	return (
		<FormProvider methods={methods} onSubmit={onSubmit}>
			<Grid container sx={{ p: 3 }} spacing={3} alignItems={"center"}>
				<Grid item>
					<RHFTextField label={translate("Organización")} name='clientName' />
				</Grid>
				<Grid item>
					<RHFTextField label={translate("Email")} name='email' />
				</Grid>
				<Grid item>
					<LoadingButton
						fullWidth
						loading={isLoading}
						size='large'
						type='submit'
						variant='contained'
					>
						{translate("Crear")}
					</LoadingButton>
				</Grid>
			</Grid>
		</FormProvider>
	);
}
